/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9.1406 0a.7031.7031 0 0 1 .1264 1.395l-.1264.0112H4.922c-1.864 0-3.3891 1.4507-3.5082 3.2845l-.0074.2312V19.078c0 1.864 1.4506 3.3891 3.2844 3.5082l.2312.0075H19.078c1.864 0 3.3891-1.4506 3.5082-3.2845l.0075-.2312v-4.2187a.703.703 0 0 1 1.3949-.1264l.0113.1264v4.2187c0 2.6277-2.0591 4.7744-4.6518 4.9146L19.0781 24H4.9219C2.2942 24 .1475 21.9409.0073 19.3482L0 19.0781V4.9219C0 2.2942 2.0591.1475 4.6518.0073L4.9218 0h4.2188ZM24 .7507V6.75a.75.75 0 0 1-1.4879.1348L22.5 6.75V2.5607l-9.9697 9.9696a.7502.7502 0 0 1-1.1474-.9568l.0868-.1038L21.4393 1.5H17.25a.7502.7502 0 0 1-.7379-.6152L16.5.75a.7502.7502 0 0 1 .6152-.738L17.25 0H24v.7507Z"
    clipRule="evenodd"
  />,
  'ExternalLink'
);
